document.addEventListener('turbo:load', fadeInImages);
document.addEventListener('DOMContentLoaded', fadeInImages);

function fadeInImages() {
  var imgs = document.querySelectorAll('img.image-fadein, #project-image');
  imgs.forEach(function(img) {
    if (img.classList.contains('show')) return;
    // Se a imagem já está carregada OU não tem atributo src (por exemplo, erro de carregamento), mostrar
    if (img.complete && img.naturalWidth !== 0) {
      img.classList.add('show');
    } else {
      img.addEventListener('load', function handler() {
        img.classList.add('show');
        img.removeEventListener('load', handler);
      });
      // Em caso de erro de carregamento, mostrar mesmo assim para não ficar oculta
      img.addEventListener('error', function handler() {
        img.classList.add('show');
        img.removeEventListener('error', handler);
      });
    }
  });
}
